var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.6646C0 1.01979 0.369365 0.49707 0.825 0.49707H21.175C21.6306 0.49707 22 1.01979 22 1.6646C22 2.30941 21.6306 2.83213 21.175 2.83213H0.825C0.369365 2.83213 0 2.30941 0 1.6646ZM0 10.9996C0 10.3548 0.369365 9.83203 0.825 9.83203H15.3855C15.8412 9.83203 16.2105 10.3548 16.2105 10.9996C16.2105 11.6444 15.8412 12.1671 15.3855 12.1671H0.825C0.369365 12.1671 0 11.6444 0 10.9996ZM0.825 19.167C0.369365 19.167 0 19.6897 0 20.3345C0 20.9793 0.369365 21.5021 0.825 21.5021H21.175C21.6306 21.5021 22 20.9793 22 20.3345C22 19.6897 21.6306 19.167 21.175 19.167H0.825Z",
    fill: "url(#paint0_linear_2049_84570)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2049_84570",
    x1: 0,
    y1: 10.9996,
    x2: 22,
    y2: 10.9996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B2650"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#015F8B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.5b446ed750841c6a249654b401aff719.svg";
export { ForwardRef as ReactComponent };